
import { ProductGroup } from "@/models/base/product-group";
import { ProductGroupService } from "@/services/product-group-service";
import Vue from "vue";
import AppProductGroupEditNode from "./ProductGroupEditNode.vue";
import AppContextMenu from "./ProductGroupContextMenu.vue";

export default Vue.extend({
	data() {
		return {
			parentValue: new ProductGroup(),
			parentGroupId: 0,
			placeHolderGroup: new ProductGroup(),
			topLevelGroups: [] as ProductGroup[],
			contextMenuOpen: false,
			contextMenuX: 0,
			contextMenuY: 0
		};
	},
	computed: {
		canEdit():boolean {
			return ProductGroup.canEditGroups();
		},
		isContextMenuOpen():boolean {
			return this.canEdit && this.contextMenuOpen;
		}
	},
	methods: {
		openContextMenu(event: MouseEvent) {
			this.contextMenuOpen = true;
			this.contextMenuX = event.x;
			this.contextMenuY = event.y;
		},
		createNewGroup() {
			let group = new ProductGroup();
			group.Name = this.$ct("new-product-group-name").toString();
			this.placeHolderGroup.addChild(group);
			this.contextMenuOpen = false;
		},
		removeGroup(i: number) {
			this.topLevelGroups.splice(i, 1);
			this.contextMenuOpen = false;
		},
		doMove(from: string, to: string) {
			let fromPath = from.split("/").map(n => parseInt(n));
			let toPath = to.split("/").map(n => parseInt(n));
			let targetIndex = toPath.pop();
			let list = this.topLevelGroups;
			let target = new ProductGroup();
			for (let i of fromPath) {
				target = list[i];
				list = target.Children;
			}

			let toGroup = this.placeHolderGroup;
			for (let i of toPath) {
				toGroup = toGroup.Children[i];
			}
			toGroup.addChild(target, targetIndex);
		},
		onDrop(event: DragEvent) {
			if (!event.dataTransfer) return;
			let path = event.dataTransfer.getData("text");
			console.log(path);
			if (!path.startsWith("product-group-move")) return;
			path = path.split(":")[1];
			this.doMove(path, `${this.topLevelGroups.length}`);
		}
	},
	async created() {
		let groups = await ProductGroupService.getAllGroups();
		this.topLevelGroups = groups.map(g => g.copy());
		this.placeHolderGroup.Children = this.topLevelGroups;
		this.placeHolderGroup.Children.forEach(c => c.ParentGroup = this.placeHolderGroup);
		this.$emit("input", this.topLevelGroups);
	},
	components: {
		AppProductGroupEditNode,
		AppContextMenu
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
